import qs from 'qs';
import { ENDPOINT } from 'src/constants/api';

import { baseApi } from './base';

const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: ({username, password} : {username: string, password: string}) => ({
        url: `${ENDPOINT}/auth/login`,
        method: 'POST',
        body: {username, password},
      }),
    }),
    metadata: builder.mutation({
      query: (accountId: number) => ({
        url: `admin/account/metadata/${accountId}`,
        method: 'GET'
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: 'auth/logout',
        method: 'POST'
      }),
    }),
    loginAsUser: builder.mutation({
      query: (userId: number) => ({
        url: `admin/users/${userId}/token`,
        method: 'GET'
      }),
    }),
    fetchAccountsPage: builder.mutation({
      query: (
        {page, country, status, sort, sort_direction}:
        {page: number, country?: number, status?: string, sort?: string, sort_direction?: string}
      ) => {
        const params = {
          sort: sort || 'name',
          page,
          per_page: 1000,
          ...(sort_direction && { sort_direction }),
          ...(country && { country }),
          ...(status && { status })
        };
        return ({
          url: `admin/account?${qs.stringify(params)}`,
          method: 'GET'
        })
      },
    }),
    fetchAccountUsersPage: builder.mutation({
      query: ({accountId, page}: {accountId: number, page: number}) => {
        const params = { sort: 'name', page, per_page: 100 };
        return ({
          url: `admin/users?account=${accountId}?${qs.stringify(params)}`,
          method: 'GET'
        })
      },
    }),
    retrieve: builder.mutation({
      query: (username: string) => ({
        url: `${ENDPOINT}/auth/forgot-password`,
        method: 'POST',
        body: {
          email: username,
          domain: 'https://' + window.location.hostname
        }
      }),
    }),
    reset: builder.mutation({
      query: ({password, pathname}: {password: string, pathname: string}) => ({
        url: `${ENDPOINT}${pathname}`,
        method: 'POST',
        body: {
          password
        },
        headers: {}
      }),
    }),
  })
});

export const {
  useLoginMutation,
  useMetadataMutation,
  useLogoutMutation,
  useLoginAsUserMutation,
  useFetchAccountsPageMutation,
  useFetchAccountUsersPageMutation,
  useRetrieveMutation,
  useResetMutation
} = authApi;
